import { config } from "@/config";
export const CategoriaService = {
    async getById(id) {
        const response = await fetch(`${config.API_URL}/api/Categoria/${id}`);
        if (!response.ok)
            throw new Error(`Error al obtener categoría con id ${id}`);
        const result = await response.json();
        return result.datos;
    },
    async getAll() {
        const response = await fetch(`${config.API_URL}/api/Categoria`);
        if (!response.ok)
            throw new Error("Error al obtener categorías");
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos))
            return [];
        return result.datos;
    },
    async getPaginated(page = 1, search = "", letter = "", departamentoId) {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (search)
            params.append("search", search);
        if (letter)
            params.append("letter", letter);
        if (departamentoId)
            params.append("departamentoId", departamentoId.toString());
        const response = await fetch(`${config.API_URL}/api/Categoria/paginated?${params.toString()}`);
        if (!response.ok)
            throw new Error("Error al obtener categorías paginadas");
        const result = await response.json();
        return result.datos;
    },
    async getByDepartamento(departamentoId) {
        const response = await fetch(`${config.API_URL}/api/Categoria/departamento/${departamentoId}`);
        if (!response.ok)
            throw new Error("Error al obtener categorías por departamento");
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos))
            return [];
        return result.datos;
    },
    async add(categoria) {
        const response = await fetch(`${config.API_URL}/api/Categoria`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(categoria),
        });
        if (!response.ok)
            throw new Error("Error al agregar categoría");
    },
    async update(id, categoria) {
        const response = await fetch(`${config.API_URL}/api/Categoria/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(categoria),
        });
        if (!response.ok)
            throw new Error("Error al actualizar categoría");
    },
    async delete(id) {
        const response = await fetch(`${config.API_URL}/api/Categoria/${id}`, {
            method: "DELETE",
        });
        if (!response.ok) {
            let msg = "Error al eliminar categoría";
            try {
                const err = await response.json();
                if (err.message)
                    msg = err.message;
            }
            catch (_) { }
            throw new Error(msg);
        }
    },
    async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/Categoria/${id}/toggle-activo`, {
            method: "PUT",
        });
        if (!response.ok)
            throw new Error("Error al cambiar el estado");
        return { exito: true };
    },
    async exportReport(request) {
        try {
            const response = await fetch(`${config.API_URL}/api/Categoria/export`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                body: JSON.stringify(request),
            });
            if (!response.ok)
                throw new Error("Error al exportar el reporte de categorías");
            const format = request.format || "excel";
            const extension = format === "pdf" ? "pdf" : "xlsx";
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const timestamp = new Date()
                .toISOString()
                .replace(/[:.]/g, "-")
                .slice(0, 19);
            link.setAttribute("download", `Categorias_${timestamp}.${extension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error("Error al exportar el reporte:", error);
            throw error;
        }
    },
};
